// extracted by mini-css-extract-plugin
module.exports = {"titleArrow":"SectionTitleArrow_titleArrow__SpRaZ"};